module.exports = __webpack_public_path__ + "img/矩形.9b31544d.png";